export default __webpack_public_path__ + "static/media/eth-white.9a178671.svg";